import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  // auth routes
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/index.vue'),
    children: [
      {
        path: 'confirmsession',
        name: 'confirmsession',
        component: () => import('../views/auth/confirmsession.vue'),
        meta: {
          title: 'Verificando sesión',
        },
      },
    ],
  },
  // app routes
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'app-home',
        // component: () => import('../views/app/home.vue'),
        meta: {
          title: 'Inicio',
        },
        redirect: { path: '/app/services/fireweb' },
      },
      // services
      {
        path: 'services',
        name: 'app-services',
        component: () => import('../views/app/services/index.vue'),
        meta: {
          title: 'Services',
        },
        children: [
          {
            path: '',
            name: 'services-list',
            component: () => import('../views/app/services/list.vue'),
            meta: {
              title: 'List of services',
            },
          },
          {
            path: ':name',
            name: 'service-details',
            component: () => import('../views/app/services/service-details.vue'),
            meta: {
              title: 'Service details',
            },
          },
        ],
      },
      // payments
      {
        path: 'payments',
        name: 'app-payments',
        component: () => import('../views/app/payments/index.vue'),
        meta: {
          title: 'Payments',
        },
        children: [
          {
            path: 'confirm',
            name: 'app-payments-confirm',
            component: () => import('../views/app/payments/confirm.vue'),
            meta: {
              title: 'Confirm Payment',
            },
          },
        ],
      },
      // invoices
      {
        path: 'invoices',
        name: 'app-invoices',
        component: () => import('@/views/app/invoices/index.vue'),
        meta: {
          title: 'Invoices',
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            name: 'app-invoices-list',
            component: () => import('@/views/app/invoices/list.vue'),
            meta: {
              title: 'Invoices list',
              requiresAuth: true,
            },
          },
          {
            path: 'view/:id',
            name: 'app-invoices-view',
            component: () => import('@/views/app/invoices/view.vue'),
            meta: {
              title: 'View Invoice',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Set title
  if (to.meta.title) {
    document.title = `${to.meta.title} - digi subscriptions`;
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!localStorage.getItem('token')) {
      const path = window.location.pathname;
      const query = window.location.search;
      const { VUE_APP_DG_APP_USERS } = process.env;
      const url = `${VUE_APP_DG_APP_USERS}/auth/provider?app=subscriptions&to=${path}${query}`;
      window.location.href = url;
    } else {
      next();
    }
  }

  if (typeof to.query.redirect === 'string' && !to.path.startsWith('/auth')) {
    next(false);
    setTimeout(() => {
      router.push(to.query.redirect as string);
    });
    return;
  }

  next();
});

export default router;
